

<template>
  <div class="lookUpInformation">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>商户名称：</span>
          <div>
            <el-autocomplete
              v-model="merchantsid"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              placeholder="单行输入"
            ></el-autocomplete>
          </div>
        </div>
        <div class="item">
          <span style="width: 30px;"></span>
          <el-button type="primary" @click="merchantsSearch" size="small">搜索</el-button>
          <el-button type="primary" @click="merchantsReset" plain size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            fixed="left"
            prop="merchantName"
            label="商户名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column prop="merchant_id" label="商户ID" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="taxNo" label="纳税人识别号" width="130" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceAddr" label="地址" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceMobile" label="电话" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="accountPublic" label="开户行" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="accountName" label="账号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="isDefault" label="默认抬头与否">
            <template slot-scope="scope">
              <div v-if="scope.row.isDefault == '0'">否</div>
              <div v-if="scope.row.isDefault == '1'">是</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
export default {
  data() {
    return {
      total: null,
      pageSize: 10,
      merchantsid: "",
      restaurants: [],
      tableData: []
    };
  },
  components: {
    pagination: pagination
  },
  mounted() {
    this.restaurants = JSON.parse(localStorage.getItem("merchantsList")) || [];
    this.merchantTitleListPost();
  },
  methods: {
    merchantTitleListPost(size) {
      const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.merchantTitleList, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        merchantId: this.merchantsid
      }).then(
        d => {
          console.log(d.status);
          loading.close();
          if (d.status === 0) {
            console.log(d, "??????????????");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 重置
    merchantsReset() {
      this.merchantsid = "";
      this.merchantTitleListPost();
    },
    merchantsSearch() {
      this.merchantTitleListPost();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条aaaaa`);
      this.pageSize = val;
      this.merchantTitleListPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.merchantTitleListPost(val);
    },
    handleClose(done) {
      done();
    },
    handleSelect(item) {
      console.log(item);
      this.merchantsid = item.id;
    },
    loadAll() {
      return [{ value: "三全鲜食（北新泾店）", address: "长宁区新渔路144号" }];
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
  }
};
</script>

<style lang="less" scoped>
.lookUpInformation {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
    .dialog-header {
      width: 100%;
      height: 49px;
      line-height: 49px;
      background: rgba(20, 147, 250, 0.1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      div {
        float: left;
        width: 116px;
        height: 49px;
        background: rgba(20, 147, 250, 1);
        color: #ffffff;
        text-align: center;
        margin-right: 28px;
      }
    }
    .dialong-content {
      width: 100%;
      height: 565px;
      background: rgba(216, 216, 216, 0.28);
      margin-top: 23px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchants/client/lookUpInformation.vue